export const LOCALES = ["es-ES", "en-US"]

export const DEFAULT_LOCALE = "es-ES"

export const MARKETING_FIELDS = ["utm_source", "utm_medium", "utm_campaign"]
